import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getQuotationSellerListById, getSalesInquiryData} from "../../store/Sales/actions";
import {formatModifyDate, getInternalRoute} from "../../components/Common/CommonLogic";
import {QueriesColVal} from "../Sales/partials/SalesCol";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import {CommonValue} from "../Parties/PartiesCol";
import Page from "../../components/GlobalComponent/PageComponent";
import MyBidsTable from "./component/MyBidsTable";
import { eye_icon } from "../../assets/images";

const MyBids = () => {
    document.title = "My Bids || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { inquiry_data_loader, inquiry_data } = useSelector((state) => state?.sales);
    const [isRight, setIsRight] = useState(false);
    const { inquiry_summary_data, quotation_seller_history_list } = useSelector((state) => state?.sales);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [showSellerList, setShowSellerList] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [modalStyle, setModalStyle] = useState({});
    const tableRef = useRef(null);
    const [rowData, setRowData] = useState(null);

    useEffect(() => {console.log("UseEffect")},[])

    const dispatch = useDispatch();
    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=${filterDetails?.isExcelGenerated ? inquiry_data?.totalElements : 10}&`;
        url += `${filters?.customer?.id ? `customers=${filters?.customer.id}&` : ''}`;
        url += `${filters?.org_port?.id ? `origins=${filters?.org_port.id}&` : ''}`;
        url += `${filters?.dest_port?.id ? `destinations=${filters?.dest_port.id}&` : ''}`;
        url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
        url += `${filters?.valid_from ? `validFrom=${filters?.valid_from}&` : ''}`;
        url += `${filters?.valid_to ? `validTo=${filters?.valid_to}&` : ''}`;
        url += `${filters?.status?.id ? `status=${filters?.status?.id}&` : ''}`;
        url += `${filters?.container_type?.id ? `containerType=${filters?.container_type?.id}&` : ''}`;
        url += `${filterDetails?.isExcelGenerated ? `isExcelGenerated=${true}&` : ''}`;
        url += 'requestForRates=false&';
        return url.substring(0, url.length - 1); // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getSalesInquiryData(url));
    };

    const clearValueHandler = () => {
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        dispatch(getSalesInquiryData(url));
    };
    useEffect(() => {
        let url = constructUrl(currentPage, filterDetails);
        console.log(url);
        dispatch(getSalesInquiryData(url));
    }, [currentPage]);

    const onClickQuoteNow = (data) => {
        navigate(getInternalRoute("instant-search-rate"), { state: { data: data }, });
    }

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getSalesInquiryData(url));
    }

    const handleRowClick = (row, rowRect) => {
        setSelectedRow(row);

        // Get current scroll position
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const scrollX = window.scrollX || document.documentElement.scrollLeft;

        // Approximate modal dimensions (adjust based on content)
        const modalPadding = 10;
        const modalWidth = 500; // Adjust based on actual modal width
        const modalHeight = 180; // Adjust based on actual modal height

        // Default modal position (below the clicked row)
        let topPosition = rowRect.bottom + scrollY + modalPadding;
        let leftPosition = rowRect.left + scrollX;

        // Adjust modal if it goes off the right screen edge
        if (leftPosition + modalWidth > window.innerWidth) {
            leftPosition = window.innerWidth - modalWidth - modalPadding; // Shift left
        }

        // Adjust modal if it goes off the bottom screen edge
        if (topPosition + modalHeight > window.innerHeight + scrollY) {
            topPosition = rowRect.top + scrollY - modalHeight - modalPadding; // Show above row
        }

        // Ensure modal is always within the viewport
        topPosition = Math.max(modalPadding, Math.min(topPosition, window.innerHeight + scrollY - modalHeight));
        leftPosition = Math.max(modalPadding, Math.min(leftPosition, window.innerWidth + scrollX - modalWidth));

        // Set modal style dynamically
        setModalStyle({
            top: `${topPosition}px`,
            left: `${leftPosition}px`,
            position: "absolute",
            zIndex: 1050, // Higher than Bootstrap modals
            backgroundColor: "white",
            border: "1px solid #ccc",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            padding: "15px",
            borderRadius: "8px",
            width: "auto",
            height: "auto",
            maxWidth: `${window.innerWidth * 0.9}px`,
            maxHeight: `${window.innerHeight * 0.7}px`,
            overflow: "auto", // Scroll if content overflows
        });

        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    }

    const handleOnSellerIdClick = (sellerId, rowRect) => {
        dispatch(getQuotationSellerListById(sellerId));
        setRowData(rowRect)
    }

    useEffect(() => {
        console.log(rowData, "rowData");
        console.log(quotation_seller_history_list, "quotation_seller_history_list");
        if (rowData != null && quotation_seller_history_list != null) {
            // Get current scroll position
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            const scrollX = window.scrollX || document.documentElement.scrollLeft;

            // Approximate modal dimensions (adjust based on content)
            const modalPadding = 10;
            const modalWidth = 500; // Adjust based on actual modal width
            const modalHeight = 180; // Adjust based on actual modal height

            // Default modal position (below the clicked row)
            let topPosition = rowData.bottom + scrollY + modalPadding;
            let leftPosition = rowData.left + scrollX;

            // Adjust modal if it goes off the right screen edge
            if (leftPosition + modalWidth > window.innerWidth) {
                leftPosition = window.innerWidth - modalWidth - modalPadding; // Shift left
            }

            // Adjust modal if it goes off the bottom screen edge
            if (topPosition + modalHeight > window.innerHeight + scrollY) {
                topPosition = rowData.top + scrollY - modalHeight - modalPadding; // Show above row
            }

            // Ensure modal is always within the viewport
            topPosition = Math.max(modalPadding, Math.min(topPosition, window.innerHeight + scrollY - modalHeight));
            leftPosition = Math.max(modalPadding, Math.min(leftPosition, window.innerWidth + scrollX - modalWidth));

            // Set modal style dynamically
            setModalStyle({
                top: `${topPosition}px`,
                left: `${leftPosition}px`,
                position: "absolute",
                zIndex: 1050, // Higher than Bootstrap modals
                backgroundColor: "white",
                border: "1px solid #ccc",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                padding: "15px",
                borderRadius: "8px",
                width: "auto",
                height: "auto",
                maxWidth: `${window.innerWidth * 0.9}px`,
                maxHeight: `${window.innerHeight * 0.7}px`,
                overflow: "auto", // Scroll if content overflows
            });

            setShowSellerList(true);
        }
    }, [quotation_seller_history_list]);

    const viewBids = (data) => {
        console.log(data);
        navigate('/view/bids', {
            state: {
                data: data
            },
        });
    };

    const columns = useMemo(() => [
        {
            Header: 'Inquiry Type',
            accessor: 'inquiryType',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Inquiry Dt',
            accessor: 'inquiryDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.inquiryDate)}</span>
                )
            }
        },
        {
            Header: 'Inquiry Id',
            accessor: 'inquiryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Shipper Name',
            accessor: 'shipperName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Shipper Location',
            accessor: 'shipperLocations',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Bids Breakdown',
            accessor: 'bidsBreakdown',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Bids Total Amount',
            accessor: 'salesEmp',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <CommonValue
                    cellProps={cellProps}
                    viewPopupHandler={viewBids}
                />
            }
        },
        {
            Header: 'View Quote',
            accessor: 'viewDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <div className="d-flex justify-content-center align-items-center h-100">
                    <img src={eye_icon} alt="Eye" onClick={() => { console.log(cellProps.row?.original) }} />
                </div>
            }
        },
        {
            Header: 'Ranking',
            accessor: 'bidsPositions',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <CommonValue
                    cellProps={cellProps}
                    viewPopupHandler={viewBids}
                />
            }
        },
        {
            Header: 'Won/Lost',
            accessor: 'wonlost',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <CommonValue
                    cellProps={cellProps}
                    viewPopupHandler={viewBids}
                />
            }
        }
    ], []);

    return (
        <>
            <Page>
                <MyBidsTable
                    tableRef={tableRef}
                    columns={columns}
                    data={!!inquiry_data.content ? inquiry_data.content : []}
                    isGlobalFilter={true}
                    isAddInvoiceList={true}
                    loader={inquiry_data_loader}
                    customPageSize={10}
                    toggleRightCanvas={toggleRightCanvas}
                    downLoadExcelReport={downLoadExcelReport}
                    component={'inquiry'}
                    setCurrentPage={setCurrentPage}
                    totalPages={inquiry_data?.totalPages || 0}
                    totalEntries={inquiry_data?.totalElements || 0}
                />
            </Page>
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
        </>
    );
}

export default MyBids;
